import { getInfo } from '@/api/user'
import { getToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  personalId: getToken('personalId'),
  uid: '',
  userInfo: {},
  signInfo: JSON.parse(localStorage.getItem('signInfo')) || {}
  // {
  // courseId: '4daf464f89e343bbb7f2b233d06b551c',
  // picImageFileId: 'a920cf50691c409eb1301497dc9881bc',
  // edu: '小学',
  // eduImageFileId: '9d4eb43eb9044190a19563e5fd58d84a',
  // firstTime: '',
  // openid: 'oSgpWv9yhoG3i3FdwaDHZj9JQoS0',
  // sex: '女',
  // signImageFileId: '407f71d5ff344e24853eba34b6786078',
  // testType: 1,
  // userAddress: '上海市西藏南路-瞿溪路弘辉名苑',
  // userCardNum: '371002200610020000',
  // userName: '方大呆',
  // userTel: '15639288793',
  // workCorp: '1',
  // channelId: '1',
  // orgId: '3988a33604ce4583a075f04bd2977961',
  // rechargeType: 2,
  // },
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_PERSONALID: (state, personalId) => {
    state.personalId = personalId
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
    state.uid = info.uid
  },
  SET_SIGN_INFO: (state, info) => {
    const obj2 = {
      ...state.signInfo,
      ...info
    }
    state.signInfo = {
      ...obj2
    }
    console.log(state.signInfo, 'state.signInfo')
    localStorage.setItem('signInfo', JSON.stringify(obj2))
  },
  INIT_SIGN_INFO: (state, info) => {
    state.signInfo = {}
    const obj2 = {
      openid: state.signInfo.openid,
      channelId: state.signInfo.channelId,
      testType: 1
    }
    state.signInfo = obj2
    localStorage.setItem('signInfo', JSON.stringify(obj2))
  }
}

const actions = {
  // 获取基本用户信息
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({ personalId: state.personalId })
        .then((res) => {
          const data = res.data
          if (!data) {
            reject(new Error('获取基本信息失败，请重新登录'))
          }
          commit('SET_USER_INFO', data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 重置token
  resetToken ({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
